export const HEADER_HEIGHT: number = 8; // in rem
